/* FITPEAK合トレナビ：トップ（/pages/gotore-navi）とエリアページ（/pages/gotore-<県>）
   件数・新着を my.fitpeak.co/api/gotore/public/overview から入れる（ログイン不要。名前・本文・IDは返ってこない）。
   取れないとき・0件のときは、サーバー描画の文言のまま（数字は出さない）。テスト: scripts/test/gotore-navi.test.cjs */
(function () {
  var API = 'https://my.fitpeak.co/api/gotore/public/overview';
  var SLUGS = {
    '北海道': 'hokkaido', '青森県': 'aomori', '岩手県': 'iwate', '宮城県': 'miyagi', '秋田県': 'akita', '山形県': 'yamagata', '福島県': 'fukushima',
    '茨城県': 'ibaraki', '栃木県': 'tochigi', '群馬県': 'gunma', '埼玉県': 'saitama', '千葉県': 'chiba', '東京都': 'tokyo', '神奈川県': 'kanagawa',
    '新潟県': 'niigata', '富山県': 'toyama', '石川県': 'ishikawa', '福井県': 'fukui', '山梨県': 'yamanashi', '長野県': 'nagano', '岐阜県': 'gifu',
    '静岡県': 'shizuoka', '愛知県': 'aichi', '三重県': 'mie', '滋賀県': 'shiga', '京都府': 'kyoto', '大阪府': 'osaka', '兵庫県': 'hyogo',
    '奈良県': 'nara', '和歌山県': 'wakayama', '鳥取県': 'tottori', '島根県': 'shimane', '岡山県': 'okayama', '広島県': 'hiroshima', '山口県': 'yamaguchi',
    '徳島県': 'tokushima', '香川県': 'kagawa', '愛媛県': 'ehime', '高知県': 'kochi', '福岡県': 'fukuoka', '佐賀県': 'saga', '長崎県': 'nagasaki',
    '熊本県': 'kumamoto', '大分県': 'oita', '宮崎県': 'miyazaki', '鹿児島県': 'kagoshima', '沖縄県': 'okinawa'
  };
  var SLOTS = { wd_am: '平日朝', wd_pm: '平日昼', wd_night: '平日夜', we_am: '土日朝', we_pm: '土日昼', we_night: '土日夜' };
  var PARTS = { chest: '胸', back: '背中', legs: '脚', shoulders: '肩', arms: '腕', full: '全身', cardio: '有酸素' };
  var LEVELS = { beginner: '初心者', intermediate: '中級者', advanced: '上級者', competitor: '大会出場' };

  function prefUrl(pref) { return SLUGS[pref] ? '/pages/gotore-' + SLUGS[pref] : '/pages/gotore-navi'; }

  /* 2026-10-19 オーナー指示: 「募集を待っている人」の人数の代わりに公式LINEの友だち数を出す（business-hubの実数＋導入前からの友だち）。見出しは「全国で合トレ待ちの友だち：n人」 */
  var FRIENDS_URL = 'https://my.fitpeak.co/api/line-crm/public/friend-count';
  function friendLine(d) {
    var n = d ? Math.floor(Number(d.total)) : NaN;
    if (!isFinite(n) || n <= 0) return null;
    return '全国で合トレ待ちの友だち：' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '人';
  }
  function showFriends() {
    var hl = document.querySelector('[data-gn-live]');
    if (!hl || typeof fetch !== 'function') return;
    fetch(FRIENDS_URL).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var t = friendLine(d);
      if (t) { hl.textContent = t; hl.hidden = false; }
    }).catch(function () {});
  }

  function badge(a) {
    if (!a) return '';
    if (+a.open_posts > 0) return '募集' + (+a.open_posts) + '件';
    return '';
  }

  /* 都道府県の一覧（4列）用の短い形 */
  function badgeShort(a) {
    if (!a) return '';
    if (+a.open_posts > 0) return '募集' + (+a.open_posts) + '件';
    return '';
  }

  function label(list, map) {
    var out = [];
    for (var i = 0; i < (list || []).length; i++) if (map.hasOwnProperty(list[i])) out.push(map[list[i]]);
    return out.join('・');
  }

  function recentItems(recent) {
    var out = [];
    for (var i = 0; i < (recent || []).length; i++) {
      var r = recent[i] || {}, g = r.gym || {};
      var handle = String(g.handle || '');
      var href;
      if (handle.indexOf('area:') === 0) href = prefUrl(g.pref) + (g.city ? '#' + encodeURIComponent(g.city) : '');
      else href = '/blogs/gym-review/' + encodeURIComponent(handle);
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(r.date || '');
      out.push({
        href: href,
        name: String(g.name || ''),
        where: String(g.pref || '') + String(g.city || ''),
        cond: [label(r.slots, SLOTS), label(r.parts, PARTS), LEVELS.hasOwnProperty(r.level) ? LEVELS[r.level] : ''].filter(Boolean).join('／'),
        date: m ? (+m[2]) + '月' + (+m[3]) + '日' : ''
      });
    }
    return out;
  }

  function overviewUrl(pref) { return API + (pref && SLUGS[pref] ? '?pref=' + encodeURIComponent(pref) : ''); }
  var memo = {};
  function fetchOverview(pref) {
    var u = overviewUrl(pref);
    if (!memo[u]) memo[u] = fetch(u).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return memo[u];
  }

  window.fpGotoreNavi = { SLUGS: SLUGS, prefUrl: prefUrl, friendLine: friendLine, badge: badge, badgeShort: badgeShort, recentItems: recentItems, overviewUrl: overviewUrl, fetchOverview: fetchOverview, data: null };

  /* ---------- 画面 ---------- */
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  function fillRecent(box, items) {
    if (!box || !items.length) return;
    var list = box.querySelector('[data-gn-recent-list]');
    if (!list) return;
    list.innerHTML = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var a = el('a', 'gn-recent__item'); a.href = it.href;
      a.appendChild(el('span', 'gn-recent__name', it.name));
      a.appendChild(el('span', 'gn-recent__where', it.where));
      if (it.cond) a.appendChild(el('span', 'gn-recent__cond', it.cond));
      if (it.date) a.appendChild(el('span', 'gn-recent__date', it.date));
      list.appendChild(a);
    }
    box.hidden = false;
    var empty = document.querySelector('[data-gn-recent-empty]');
    if (empty) empty.hidden = true;
  }

  function setBadge(node, a, short) {
    var b = short ? badgeShort(a) : badge(a);
    if (!b) return;
    var s = node.querySelector('.gn-badge') || node.appendChild(el('span', 'gn-badge'));
    s.textContent = b;
  }

  function apply(d, root) {
    var i, nodes;
    nodes = document.querySelectorAll('[data-gn-pref]');
    for (i = 0; i < nodes.length; i++) {
      for (var j = 0; j < (d.prefs || []).length; j++) if (d.prefs[j].pref === nodes[i].getAttribute('data-gn-pref')) setBadge(nodes[i], d.prefs[j], true);
    }
    nodes = document.querySelectorAll('[data-gn-city]');
    for (i = 0; i < nodes.length; i++) {
      for (var k = 0; k < (d.areas || []).length; k++) if (d.areas[k].city === nodes[i].getAttribute('data-gn-city')) setBadge(nodes[i], d.areas[k]);
    }
    nodes = document.querySelectorAll('[data-gn-gym]');
    for (i = 0; i < nodes.length; i++) {
      for (var g = 0; g < (d.gyms || []).length; g++) if (d.gyms[g].handle === nodes[i].getAttribute('data-gn-gym')) setBadge(nodes[i], d.gyms[g]);
    }
    fillRecent(document.querySelector('[data-gn-recent]'), recentItems(d.recent));
  }

  function init() {
    var root = document.querySelector('[data-gotore-navi]');
    if (!root) return;
    showFriends();
    var pref = root.getAttribute('data-gn-pref-scope') || '';
    fetchOverview(pref).then(function (d) {
      if (!d || !d.totals) return;
      apply(d, root);
      /* ほかのスクリプトが使えるように残す（2026-10-17 近未来UIは外した。archive/gotore-x-20261017） */
      window.fpGotoreNavi.data = d;
      try { window.dispatchEvent(new CustomEvent('fpgn:data', { detail: d })); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
